import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchAmenities } from '../../actions/amenities';
import { fetchFuelsByStation } from '../../actions/fuels';
import { fetchStationInfo } from '../../actions/station-info';
import { DISPLAY_FUEL_TYPES } from '../../constants';
import { getReviewsByStationIdFromReducer } from '../../reducers/reviews';
import Station from './Station';

function mapStateToProps({ amenities, fuels, reviews, stationHours, stationInfo, user }, { match }) {
  const { stationId } = match.params;
  const station = stationInfo.stationsById[stationId];

  const stationFuels = Object.values(fuels.fuelsByStationId[stationId] || [])
    .filter(fuel => DISPLAY_FUEL_TYPES.includes(fuel.displayName));

  return {
    amenities: Object.values(amenities.byId),
    fuels: stationFuels,
    hours: stationHours.byStationId[stationId],
    isFetching: stationInfo.isFetching,
    reviews: getReviewsByStationIdFromReducer(stationId, reviews),
    station: {
      ...station,
      reviewCount: reviews.pagingByStationId[stationId]?.totalRecords,
    },
    stationId,
    user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAmenitiesByStation: stationId => dispatch(fetchAmenities(stationId)),
    fetchFuelsByStation: stationId => dispatch(fetchFuelsByStation(stationId)),
    fetchStationInfo: stationId => dispatch(fetchStationInfo(stationId)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Station));
